export enum ENTITIES {
  PROCESS_DEFINITION = 'process-definition',
  PROCESS_INSTANCE = 'process-instance',
  PROCESS_INSTANCE_PLURAL = 'process-instances',
  TASK = 'task',
  TASK_PLURAL = 'tasks',
  START_PROCESS = 'start-process',
}
